# Network Configuration

Dynamically picks up each network connection and displays the current usage for each of your network connections.

## Network Names

The names for each connection are direct from your operating system, and cannot be changed in CanvasPro.
You may be able to change these in your operating system and CanvasPro will rapidly pickup the new names.
